import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Guard that checks if the platform is in maintenance mode.
 * Calls GET /auth/me — a lightweight authenticated endpoint subject to the backend MaintenanceGuard.
 * If the backend returns 503 with maintenanceMode, redirects to /maintenance.
 * Any other error allows navigation to proceed (auth/permission errors handled elsewhere).
 */
export const maintenanceGuard: CanActivateFn = () => {
  const http = inject(HttpClient);
  const router = inject(Router);

  return http.get<unknown>(`${environment.apiUrl}/auth/me`).pipe(
    map(() => true),
    catchError((error: { status: number; error?: { maintenanceMode?: boolean; error?: { message?: string }; scheduledDate?: string; scheduledTime?: string } }) => {
      if (error.status === 503 && error.error?.maintenanceMode) {
        router.navigate(['/maintenance'], {
          state: {
            message: error.error.error?.message ?? 'System is under maintenance. Please try again later.',
            scheduledDate: error.error.scheduledDate,
            scheduledTime: error.error.scheduledTime,
          },
        });
        return of(false);
      }
      return of(true);
    }),
  );
};
